"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.site_index = void 0;
exports.site_index = "/{?region,name,placeId,occupancy,overrideHost,checkIn,checkOut,dd}";
